/**
 * Created by Shiv Roy on 25/9/17.
 */
import { change, Field, FieldArray, formValueSelector, getFormMeta, reduxForm } from 'redux-form';
import { asyncValidateAction, getMasterData, getStaffDetailsById, SaveUserDetails, showUsersSubMenus, getPatientList, getUserRoles } from '.././actions/UserActions';
import {
  isInteger,
  isValidApartmentWithSpace,
  isValidFileType,
  isValidName,
  isValidNameWithSpace,
  normalizeMobile,  
  normalizeZipCode,
  renderAutoCompleteMultipleSelection,
  renderAutoCompleteSingleSelect,
  renderCheckBox,
  renderDateField,
  renderTextField,
  renderUploadField,
  renderTextArea,
  renderAutoCompleteScheduling,
  //RenderPasswordField,
} from '../../../components/reduxFields';
import { connect } from 'react-redux';
import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';
import React from 'react';
import validate from './validate';
import { MODULE } from '../constants/ApiConstants';
import { base64Encode, displayCustomError, extractDataFromArrayByValue, showWarningMessage, EBS, AMEGO, VIP, CBF, AIP, FUTURES, AMEGOFL, TFABA, KNOWBOUNDARIES, ARROWS, HYPERIONCENTER, isEmptyObject, STEPUPFAMILYSERVICES, CONVERGENCY } from '../../../actions/utilAction';
import { checkFieldExistence, clearFieldErrorArray } from '../../../modules/AppConfig/actions';
import Alert from 'react-s-alert';
import { CommonButton } from '../../../../src/components/buttons';
import ChangeEmailAddressModal from './ChangeEmailAddressModal';
import GooglePlaceAutocomplete from '../../../components/GooglePlaceAutocomplete';
import history from '../../../history';
import _ from 'lodash';

const styles = {
  block: {
    maxWidth: 250,
  },
  checkbox: {
    marginBottom: 16,
  },
  uploadButton: {
    verticalAlign: 'middle',
  },
  removeImageBtn: {
    border: 'none',
    padding: 7,
    width: 35,
    borderRadius: 54,
    marginLeft: 11,
  },
  uploadInput: {
    cursor: 'pointer',
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    width: '100%',
    opacity: 0,
  },
};

const validateNPI = (npiNumber) => {
  if (!npiNumber || npiNumber.trim() === '') {
    return 'Please enter NPI number';
  } else if (npiNumber && npiNumber.length < 8) {
    return 'Please enter valid NPI number';
  }
};

const validateOtherTaxonomy = (value) => !(value ? value.trim() : value) ? 'Please enter taxonomy code' : undefined;


// const validateEmployeeKronosId = (employeeKronosId) => {
//   if (!employeeKronosId || employeeKronosId.trim() === '') {
//     return 'Please enter employee kronos id';
//   } 
// };

// const validateExemptTypeId = (exemptTypeId) => {
//   if (!exemptTypeId) {
//     return 'Please select exempt type.';
//   } else if (!Number.isInteger(exemptTypeId)) {
//     return 'Please select an option.';
//   }  
// };

// const validatePayrollPositionTypeId = (payrollPositionType) => {
//   if (!payrollPositionType) {
//     return 'Please select payroll position.';
//   } else if (!Number.isInteger(payrollPositionType)) {
//     return 'Please select an option.';
//   }  
// };

// const asyncValidate = (values, dispatch, props) => {  
//   return new Promise((resolve, reject) => {
//     // console.log('inside promise..')
//     if (props.agencyName.toUpperCase() != NOVA && props.isRequirednpiNumber && values.npiNumber) {      
//       // console.log('inside condition..')
//       asyncValidateAction(values.npiNumber, resolve, reject, props.access_token);
//     } else {
//       resolve();
//     }
//   });
// };
class UserInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: null,
      dob: null,
      doj: null,
      userAvatar: '',
      filteredStatesByCountry: [],
      staffTagsModel: [],
      initialState: true,
      masterStaff: [],      
      staffTeamList: [],
      staffTeamClientsList: [],
      // showPassword: false,
      street_number: '',
      route: '',
      locality: '',
      administrative_area_level_1: '',
      country: '',
      postal_code: '',
      latitude: 0.0,
      longitude: 0.0,
      isValidAddress: true,
      Address: null,
      isTabChangeRequest: false,
      isRenderingProvider: false,
      selectAllPatient: false,
      deSelectAllPatient: false,
      selectAllStaff: false,
      deSelectAllStaff: false,
      allPatient: [],
      issueDate:[],
      expiryDate:[],
      staffLicenseOrCertificateModel:[],
      Taxonomylist: [{ id: '106S00000X', value: '106S00000X - BT' }, { id: '106E00000X', value: '106E00000X - BCaBA'  },{ id: '103K00000X', value: '103K00000X - BCBA'  },{ id: 'Other', value: 'Other' }],
      displayOtherTaxonomy: false,
      changeEmailAddressModel : false,
    };
    this.handleNewRequestTag = this.handleNewRequestTag.bind(this);
    this.handleNewRequestTeamStaff = this.handleNewRequestTeamStaff.bind(this);
    this.GetFullAddress = this.GetFullAddress.bind(this);
    this.checkRenderingProvider = this.checkRenderingProvider.bind(this);
    this.IsFullAddressEmpty = this.IsFullAddressEmpty.bind(this);
  }

  componentWillMount() {
    this.props.getMasterData('masterStaff,masterLocation,masterCountry,masterGender,masterState,staffavailability,MASTERWEEKDAYS,masterDegree,MASTERTAGSFORSTAFF,PAYROLLGROUP,EXEMPTTYPE,PAYROLLPOSITIONTYPE');
    // let searchObj = {
    //   filters: { TypeKey: 'ALL_STAFF,BOTH' },
    // };
    // this.props.getUserMasterTags(searchObj);

    this.props.getUserRoles(this.props.staffId, this.props.viewAdminRolePermission);

    let searchObj = {
      locationIds: '0',
      isActiveCheckRequired: 'YES',
    };
    this.props.getPatientList(searchObj);   

    if (this.props.staffId) {
      this.props.getStaffDetailsById(this.props.staffId);
      this.props.showUsersSubMenus(true);
    } else {
      this.props.showUsersSubMenus(false);
    }
  }

  /** *******************     Input field exist check        ***********************/
  checkFieldDataExistence = (input, value, labelName) => {
    if (value.length > 0) {
      let postData = {
        'labelName': labelName,
        'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
        'value': value,
        'colmnName': input.target.name.toUpperCase(),
        'id': this.props.initialValues && this.props.initialValues.userID ? this.props.initialValues.userID : 0,
      };
      this.props.checkFieldExistence(postData);
    }
  };
  /** *****   End Input field exist check    **********/


  componentWillReceiveProps(nextProps) {
    if (nextProps.staffId !== this.props.staffId) {
      if (nextProps.staffId) {
        this.props.showUsersSubMenus(true);
        this.props.getStaffDetailsById(nextProps.staffId);
        if (this.state.isTabChangeRequest) {
          this.setState({ isTabChangeRequest: false });
          this.props.handleUserTabChange('1');
        }
      } else {
        this.props.showUsersSubMenus(false);
        this.setState({
          userAvatar: '',
          staffTeamList: [],
          staffTeamClientsList: [],
          staffTagsModel: [],
          Address: '',
          latitude: 0.0,
          longitude: 0.0,
        });
      }
    }
    if (nextProps.master_data && nextProps.master_data !== this.props.master_data) {
      let staffsList = nextProps.master_data.staffs;
      if (staffsList && staffsList.length) {
        let filteredStaffs = staffsList.filter((obj) => obj.id !== this.props.staffId);
        this.setState({ masterStaff: filteredStaffs });
      }
    }
    let master_data = nextProps.master_data;
    if (master_data && master_data.masterState && master_data.masterState.length) {
      if (nextProps.initialValues && nextProps.initialValues.countryID && this.state.initialState === true) {
        this.getFilteredStatesList(nextProps.initialValues.countryID);
      }
    }
    if (nextProps.staffDetails && nextProps.staffDetails !== this.props.staffDetails) {
      let staffDetails = nextProps.staffDetails.data;
      let issueDate = this.state.issueDate;
      let expiryDate = this.state.expiryDate;

      (nextProps.staffDetails && nextProps.staffDetails.data.staffLicenseOrCertificateModel || []).filter((obj,index) => {
        if(obj.issueDate != undefined)
        {
          _.update(issueDate, `[${index}]`, function (n) {
              return moment(obj.issueDate).format('MM-DD-YYYY');
          });
        
          this.props.dispatch(change('UserInfoForm', `staffLicenseOrCertificateModel[${index}].issueDate`, moment(obj.issueDate).format('MM-DD-YYYY') || null));
        }

        if(obj.expiryDate != undefined)
        {
          _.update(expiryDate, `[${index}]`, function (n) {
              return moment(obj.expiryDate).format('MM-DD-YYYY');
          });

          this.props.dispatch(change('UserInfoForm', `staffLicenseOrCertificateModel[${index}].expiryDate`, moment(obj.expiryDate).format('MM-DD-YYYY') || null));
        }

        this.props.dispatch(change('UserInfoForm', `staffLicenseOrCertificateModel[${index}].id`, obj.id || 0));
      })



      this.setState({
        userAvatar: staffDetails.PhotoThumbnailPath || '',
        staffTeamList: staffDetails.staffTeamList || [],
        staffTeamClientsList: staffDetails.staffTeamClientsList || [],
        staffTagsModel: staffDetails.staffTagsModel || [],
        Address: staffDetails.address || '',
        latitude: staffDetails.latitude || 0.0,
        longitude: staffDetails.longitude || 0.0,
        isRenderingProvider: staffDetails.isRenderingProvider || false,
        issueDate:issueDate,
        expiryDate:expiryDate,
        displayOtherTaxonomy: ((staffDetails.taxonomyCode !== '' && staffDetails.taxonomyCode !== undefined && staffDetails.taxonomyCode !== '106S00000X' && staffDetails.taxonomyCode !== '106E00000X' && staffDetails.taxonomyCode !== '103K00000X') ? true : false),
      });
    }
    if (nextProps.saved_StaffDetails && nextProps.saved_StaffDetails !== this.props.saved_StaffDetails) {
      let staffId = nextProps.saved_StaffDetails.data && nextProps.saved_StaffDetails.data.id;
      if (!this.props.staffId && staffId) {
        let staffid = base64Encode(`${staffId}`);
        history.push(`/user/${staffid}`);
        // history.push(`/user/${staffId}`);
      } else if (this.state.isTabChangeRequest) {
        this.setState({ isTabChangeRequest: false });
        this.props.handleUserTabChange('1');
      } else {
        this.props.getStaffDetailsById(staffId);
      }
    }

    this.setState({allPatient: this.props.patientlist});
    
  }

  checkRenderingProvider = (e) => {
    if (e.target.checked) {
      this.setState({ isRenderingProvider: true });
    } else {
      this.setState({ isRenderingProvider: false });
    }
  }

  getFilteredStatesList = (countryID) => {
    // console.log(countryID);
    this.setState((prevState, props) => {
      let allStates = [];
      let filteredStates = [];
      if (props.master_data && props.master_data.masterState && props.master_data.masterState) {
        allStates = props.master_data.masterState;
        filteredStates = allStates.filter((Obj) => Obj.countryID === countryID);
        // console.log(filteredStates);
        return {
          filteredStatesByCountry: filteredStates,
        };
      }
    });
  }

  IsFullAddressEmpty(searchText) {
    if (searchText.length === 0)
      this.setState({ isValidAddress: false });
  }

  GetFullAddress(componentForm) {
    this.setState({
      street_number: componentForm.street_number,
      route: componentForm.route,
      locality: componentForm.locality,
      administrative_area_level_1: componentForm.administrative_area_level_1,
      country: componentForm.country,
      postal_code: componentForm.postal_code,
      latitude: componentForm.lat,
      longitude: componentForm.lng,
      isValidAddress: true,
    }, () => {
      this.props.dispatch(change('UserInfoForm', 'city', this.state.locality === 'long_name' ? '' : this.state.locality));
      this.props.dispatch(change('UserInfoForm', 'zip', this.state.postal_code === 'short_name' ? '' : this.state.postal_code));
      let countryObj = extractDataFromArrayByValue(this.props.masterCountry, this.state.country === 'short_name' ? '' : this.state.country, true);
      if (countryObj) {
        this.props.dispatch(change('UserInfoForm', 'countryID', countryObj.id));
        this.getFilteredStatesList(countryObj.id);
      }
      let stateObj = extractDataFromArrayByValue(this.state.filteredStatesByCountry, this.state.administrative_area_level_1 === 'short_name' ? '' : this.state.administrative_area_level_1, false);
      if (stateObj) {
        this.props.dispatch(change('UserInfoForm', 'stateID', stateObj.id));
      }
      let Address = this.state.street_number === 'short_name' && this.state.route === 'long_name' ? '' :
        this.state.street_number === 'short_name' ? this.state.route : this.state.street_number + ' ' + this.state.route;
      this.setState({ Address: Address });
    });
  }

  _handleImageChange(e) {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      this.setState({
        userAvatar: reader.result,
      });
    };
    if (file) {
      let isValidTypeImage = isValidFileType(file.name, 'image');
      if (!isValidTypeImage) {
        showWarningMessage('The file you are uploading does not appear to be valid.  Please check the file and try again.');
      } else {
        Alert.closeAll();
        reader.readAsDataURL(file);
      }
    }
  }

  handleRemoveImage = (e, type) => {
    e.preventDefault();
    this.setState({ userAvatar: '' });
  };


  onDateChange = (input, value, i, type) => {
    // console.log("onDateChange",input, value, i, type)

    input.onChange(moment(value).format());
    if(type === 'FROM DATE')
    {
        let issueDate = this.state.issueDate;
        _.update(issueDate, `[${i}]`, function (n) {
          return moment(value).format('YYYY-MM-DD') + 'T' + moment(value).format('HH:mm:ss');
        });

        this.setState({ issueDate: issueDate }, ()=>{                  
          document.getElementsByName(`staffLicenseOrCertificateModel[${i}].expiryDate`)[0].focus();           
      });
    }
    else if(type === 'TO DATE')
    {
        let expiryDate = this.state.expiryDate;
        _.update(expiryDate, `[${i}]`, function (n) {
          return moment(value).format('YYYY-MM-DD') + 'T' + moment(value).format('HH:mm:ss');
        });

        this.setState({ expiryDate: expiryDate }, ()=>{                  
          document.getElementsByName(`staffLicenseOrCertificateModel[${i}].issueDate`)[0].focus();           
      });
    }
  }

  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
    if (input.name === 'countryID') {
      this.getFilteredStatesList(selectedRecord.value);
      this.setState({
        initialState: false,
      });
    } else if (input.name === 'taxonomyCodeIds') {
      if (selectedRecord.value !== '') {
        if (selectedRecord.value === 'Other') {          
          this.props.dispatch(change('LocationMasterModalForm', 'taxonomyCode', null));
          this.setState({ displayOtherTaxonomy: true });
        } else {          
          this.props.dispatch(change('UserInfoForm', 'taxonomyCode', null));
          this.setState({ displayOtherTaxonomy: false });
        }
      } else {
        
        this.setState({ displayOtherTaxonomy: false });
      }
    }

  }
  handleNewRequestTag(input, value) {
    input.onChange(value);
    if (input.name === 'staffLocationList') {
      this.props.dispatch(change('UserInfoForm', 'defaultLocation', ''));
    }
  }
  handleNewRequestTeamStaff(input, value) {  
    if (input.name === 'staffTeamClientsList') {    
      this.setState({deSelectAllPatient: false});
    }
    else if (input.name === 'staffTeamList') {    
      this.setState({deSelectAllStaff: false});
    }
    
    input.onChange(value);
  }

  handleSaveContinue(formData) {
    this.setState({ isTabChangeRequest: true });
    this.onSubmit(formData);
  }

  deselectAll = (type) => { //  Uncheck All Staff/Patient    
    if (type === 'Client') {
      let selectedPatients = [];
      this.props.dispatch(change('UserInfoForm', 'staffTeamClientsList', selectedPatients));
      this.setState({ allPatient: [], selectedPatient: [] }, () => {
        this.setState({ allPatient: [{ deselectAll: true }, ...this.props.patientlist], deSelectAllPatient: true, selectAllPatient: false, selectedPatient: [] });
      });
    } 
    else if (type === 'Staff') {
      let selectedStaffs = [];
      this.props.dispatch(change('UserInfoForm', 'staffTeamList', selectedStaffs));
      this.setState({ masterStaff: [], selectedStaff: [] }, () => {
        this.setState({ masterStaff: [{ deselectAll: true }, ...this.props.master_data.staffs], deSelectAllStaff: true, selectAllStaff: false, selectedStaff: [] });
      });
    }
  };

  selectAll = (type) => { //  Check All Staff/Patient   
    if (type === 'Client') {
      let selectedPatients = this.props.patientlist.map((obj) => obj.id);
      this.props.dispatch(change('UserInfoForm', 'staffTeamClientsList', selectedPatients));
      this.setState({ allPatient: [], selectedPatient: [] }, () => {
        this.setState({ allPatient: this.props.patientlist, selectAllPatient: true, deSelectAllPatient: false, selectedPatient: selectedPatients });
      });
    }
    else if (type === 'Staff') {   
      let selectedStaffs = this.props.master_data.staffs.map((obj) => obj.id);
      this.props.dispatch(change('UserInfoForm', 'staffTeamList', selectedStaffs));
      this.setState({ masterStaff: [], selectedStaff: [] }, () => {        
        this.setState({ masterStaff: this.props.master_data.staffs, selectAllStaff: true, deSelectAllStaff: false, selectedStaff: selectedStaffs });
      });
    }
  };

  changeEmailAddress = () => {
    this.setState({changeEmailAddressModel : true});
  }

  handleClose = () => {
    this.setState({changeEmailAddressModel : false});
  }

  onSubmit = (formData) => {
    // console.log("formData",formData)
    if (this.state.Address === null || this.state.Address === '') {
      this.setState({ isValidAddress: false });
      return null;
    }
    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }
    if ((this.state.userAvatar) && (this.state.userAvatar.length > 400)) { // Add Image
      formData['PhotoBase64'] = this.state.userAvatar;
    } else if (this.state.userAvatar === '') { //  Delete Front Image
      formData['PhotoPath'] = '';
      formData['PhotoThumbnailPath'] = '';
    }
    delete formData.photo;

    if (formData.staffTeamList) {
      let teamStaffs = this.state.staffTeamList.map((Obj) => {
        return {
          'id': Obj['id'],
          'staffid': Obj['staffid'],
          'staffteamid': Obj['staffteamid'],
          'isdeleted': true,
        };
      });
      formData.staffTeamList.map((staffId) => {
        // update case for team staffs ------
        let staff = teamStaffs.find((Obj) => Obj['staffteamid'] === staffId && Obj['isdeleted']);
        if (staff) {
          let index = teamStaffs.indexOf(staff);
          teamStaffs[index] = {
            ...staff,
            'isdeleted': false,
          };
        } else {
          teamStaffs.push({
            'id': 0,
            'staffid': this.props.staffId || 0,
            'staffteamid': staffId,
            'isdeleted': false,
          });
        }
        return teamStaffs;
      });
      formData.staffTeamList = teamStaffs;

      // const ids = teamStaffs.map(o => o.staffteamid);
      // const filteredteamStaffs = teamStaffs.filter(({staffteamid}, index) => !ids.includes(staffteamid, index + 1));

      // formData.staffTeamList = filteredteamStaffs;
    }

    if (formData.staffTeamClientsList) {
      let teamClients = this.state.staffTeamClientsList.map((Obj) => {
        return {
          'id': Obj['id'],
          'staffid': Obj['staffid'],
          'staffteamclientid': Obj['staffteamclientid'],
          'isdeleted': true,
        };
      });
      formData.staffTeamClientsList.map((patientId) => {
        // update case for team staffs ------
        let staff = teamClients.find((Obj) => Obj['staffteamclientid'] === patientId && Obj['isdeleted']);
        if (staff) {
          let index = teamClients.indexOf(staff);
          teamClients[index] = {
            ...staff,
            'isdeleted': false,
          };
        } else {
          teamClients.push({
            'id': 0,
            'staffid': this.props.staffId || 0,
            'staffteamclientid': patientId,
            'isdeleted': false,
          });
        }
        return teamClients;
      });
      formData.staffTeamClientsList = teamClients;
      
      //console.log('teamClients..............',teamClients);
      // const ids = teamClients.map(o => o.staffteamclientid);
      // const filteredTeamClients = teamClients.filter(({staffteamclientid}, index) => !ids.includes(staffteamclientid, index + 1));
      // console.log('filteredTeamClients..............',filteredTeamClients);
      // formData.staffTeamClientsList = filteredTeamClients;
    }

    if (formData.staffTagsModel) {
      let tagStaffs = this.state.staffTagsModel.map((Obj) => {
        return {
          'id': Obj['id'],
          'staffID': Obj['staffID'],
          'tagID': Obj['tagID'],
          'isDeleted': true,
        };
      });
      formData.staffTagsModel.map((tagId) => {
        // update case for team staffs ------
        let tagData = tagStaffs.find((Obj) => Obj['tagID'] === tagId && Obj['isDeleted']);
        if (tagData) {
          let index = tagStaffs.indexOf(tagData);
          tagStaffs[index] = {
            ...tagData,
            'isDeleted': false,
          };
        } else {
          tagStaffs.push({
            'id': 0,
            'staffID': this.props.staffId,
            'tagID': tagId,
            'isDeleted': false,
          });
        }
        return tagStaffs;
      });
      formData.staffTagsModel = tagStaffs;
    }
    let staffLocations = (formData.staffLocationList || []).map((locationId, index) => {
      let IsDefault = locationId === formData.defaultLocation ? true : false;
      return { id: locationId, 'isDefault': IsDefault };
    });

    // let StaffLicenseOrCertificateModel = (formData.StaffLicenseOrCertificateModel).map((obj,index) => {
       
    // });

    let postData = {
      'id': this.props.staffId,
      'firstName': formData.firstName.trim(),
      'middleName': formData.middleName ? formData.middleName.trim() : '',
      'lastName': formData.lastName.trim(),
      'gender': formData.gender,
      'dob': moment(formData.dob).format('YYYY-MM-DD') + 'T' + moment(formData.dob).format('HH:mm:ss'),
      'doj': moment(formData.doj).format('YYYY-MM-DD') + 'T' + moment(formData.doj).format('HH:mm:ss'),
      // 'issueDate':moment(formData.IssueDate).format('YYYY-MM-DD') + 'T' + moment(formData.IssueDate).format('HH:mm:ss'),
      'address': this.state.Address,
      'email': formData.email,
      'npiNumber': formData.npiNumber,
      'taxId': formData.taxId,
      'userName': formData.userName,
      'password': formData.newPassword,
      'roleID': formData.roleID,
      'photoBase64': formData.PhotoBase64,
      'city': formData.city,
      'stateID': formData.stateID,
      'countryID': formData.countryID,
      'zip': formData.zip,
      'phoneNumber': formData.phoneNumber,
      'isRenderingProvider': formData.isRenderingProvider || false,
      'caqhid': formData.caqhid,
      'language': formData.language,
      'latitude': this.state.latitude,
      'longitude': this.state.longitude,
      'apartmentNumber': formData.apartmentNumber,
      'degreeID': formData.degreeID,
      'employeeID': formData.employeeID,
      //'payRate': formData.payRate,
      'payRate': 0,
      'payrollGroupID': formData.payrollGroupID,
      'staffLocationList': staffLocations,
      'staffTeamList': formData.staffTeamList || [],
      'staffTeamClientsList': formData.staffTeamClientsList || [],      
      'staffTagsModel': formData.staffTagsModel || [],
      'isExemptFromBreakCalculation': formData.isExemptFromBreakCalculation || false,
      'isExemptFromMileageCalculation': formData.isExemptFromMileageCalculation || false,      
      'note': formData.note ? formData.note.trim() : '',      
      'taxonomyCode': this.state.displayOtherTaxonomy ? formData.taxonomyCode.trim() : formData.taxonomyCodeIds,      
      'licenseNumber': formData.licenseNumber ? formData.licenseNumber.trim() : null,
      'employeeNumber': formData.employeeNumber ? formData.employeeNumber.trim() : null,
      'secondaryTaxonomyCode': formData.secondaryTaxonomyCode ? formData.secondaryTaxonomyCode.trim() : null,
      'secondaryLicenseNumber': formData.secondaryLicenseNumber ? formData.secondaryLicenseNumber.trim() : null,
      'employeeKronosId': formData.employeeKronosId ? formData.employeeKronosId.trim() : null,
      'exemptTypeId': formData.exemptTypeId ? formData.exemptTypeId : null,
      'payrollPositionTypeId': formData.payrollPositionTypeId ? formData.payrollPositionTypeId : null,
      'credentialsID': formData.credentialsID ? formData.credentialsID.trim() : null,
      'evalTitle': formData.evalTitle ? formData.evalTitle.trim() : null,
      'medicaidId': formData.medicaidId ? formData.medicaidId.trim() : null,
      'behaviorTechnicianMedicaidId': formData.behaviorTechnicianMedicaidId ? formData.behaviorTechnicianMedicaidId.trim() : null,
      'leadAnalystMedicaidId': formData.leadAnalystMedicaidId ? formData.leadAnalystMedicaidId.trim() : null,
      'isExemptFromDriveTime': formData.isExemptFromDriveTime || false,      
      'isExemptFromMileage': formData.isExemptFromMileage || false,      
      'isExemptFromOverTime': formData.isExemptFromOverTime || false,
      // 'StaffLicenseOrCertificateModel':[{
      //   'id': 0,
      //   'LicenseOrCertificateName': formData.LicenseOrCertificateName, 
      //   'LicenseOrCertificateNumber':formData.LicenseOrCertificateNumber,
      //   'IssueDate':moment(formData.IssueDate).format('YYYY-MM-DD') + 'T' + moment(formData.IssueDate).format('HH:mm:ss'), 
      //   'ExpiryDate':moment(formData.ExpiryDate).format('YYYY-MM-DD') + 'T' + moment(formData.ExpiryDate).format('HH:mm:ss'),
      // }],
    };

    let license = [];
    if(formData.staffLicenseOrCertificateModel && formData.staffLicenseOrCertificateModel.length > 0 && !isEmptyObject(formData.staffLicenseOrCertificateModel[0])){
       formData.staffLicenseOrCertificateModel.filter((data,i) => {
          let currentLicense = {
              'id': this.props.initialValues
               && this.props.initialValues.staffLicenseOrCertificateModel 
              && this.props.initialValues.staffLicenseOrCertificateModel[i] 
              && this.props.initialValues.staffLicenseOrCertificateModel[i].id  === 0 ? 0 : data.id ? data.id : 0,
              'LicenseOrCertificateName': data.LicenseOrCertificateName, 
              'LicenseOrCertificateNumber':data.LicenseOrCertificateNumber,
              'IssueDate':data.issueDate,
              'ExpiryDate':data.expiryDate 
            }
            license.push(currentLicense)
          return license;
       })
    }
    postData.staffLicenseOrCertificateModel = license
    
    // console.log('postData......', JSON.stringify(postData));
    this.props.SaveUserDetails(postData);
  };

  addRow = () => { };
  removeRow =(i) => { };

  renderLicenseTemplate = ({fields}) => {
    this.addRateRow = (e) => {
      fields.push({});

      this.setState(prevState => ({
        issueDate: [...prevState.issueDate, null],
        expiryDate: [...prevState.expiryDate, null]
      }));
    };

    this.removeRateRow = (i, e) => {
      fields.remove(i);

      this.setState(prevState => ({
        issueDate: prevState.issueDate.filter((_, index) => index !== i),
        expiryDate: prevState.expiryDate.filter((_, index) => index !== i)
      }));
    };

    return (
      <div>
        {fields.map((staffLicenseOrCertificateModel, i) => 
          <div id="currentDiv" className="row" key={i}>
            <div className="col-sm-3">
              <Field
                name={`staffLicenseOrCertificateModel[${i}].LicenseOrCertificateName`}
                type="text"
                maxLength="50"
                label="License/Certification Name"                    
                component={renderTextField}
                normalize={isValidNameWithSpace}
                // validate={validateLicenseName}
                />
                
            </div>
            <div className="col-sm-3">
              <Field
                name={`staffLicenseOrCertificateModel[${i}].LicenseOrCertificateNumber`}
                type="text"
                maxLength="50"
                label="License/Certification Number"                    
                component={renderTextField}
                normalize={isValidNameWithSpace}
                />
            </div>
            <div className="col-sm-2">
              <Field
                name={`staffLicenseOrCertificateModel[${i}].issueDate`}
                placeholder="Issue Date"
                component={renderDateField}
                locale="en-US"
                openToYearSelection={true}
                selected={this.state.issueDate[i] || null}
                onDateChange={(input, value) => this.onDateChange(input, value, i, 'FROM DATE')} 
                />
            </div>
            <div className="col-sm-2">
              <Field
                name={`staffLicenseOrCertificateModel[${i}].expiryDate`}
                placeholder="Expiry Date"
                component={renderDateField}
                locale="en-US"
                openToYearSelection={true}
                selected={this.state.expiryDate[i] || null}
                onDateChange={(input, value) => this.onDateChange(input, value, i, 'TO DATE')} />
            </div>
            <div className="col-sm-2">
              {fields.length === i + 1 ?
                <div>
                  {fields.length > 1 ?
                    <button className="additem removeitem"
                      onClick={this.removeRateRow.bind(this, i)}
                      title="Remove Rate"
                      type="button">
                      <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                    </button>
                  : ''}
                  <button className="additem" title="Add Rate" onClick={(e) => this.addRateRow()} type="button">
                    <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                  </button>
                </div>
                :
                <div>
                  
                    <button className="additem"
                      onClick={this.removeRateRow.bind(this, i)}
                      title="Remove Rate"
                      type="button">
                      <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                    </button>
                  
                </div>
              }
            </div>
          </div>
        )}
      </div>
    )
  }

  render() {
    const { handleSubmit} = this.props;
    return (
      <div>
        <div>
          <form className="readmin-form custom_form"  
            noValidate onSubmit={handleSubmit(this.onSubmit.bind(this))} >
            <div className="row">
              <div className="col-sm-4 require">
                <Field
                  autoFocus={true}
                  name="firstName"
                  type="text"
                  maxLength="40"
                  normalize={isValidNameWithSpace}
                  label="First Name"
                  component={renderTextField} />
              </div>
              <div className="col-sm-4">
                <Field
                  name="middleName"
                  type="text"
                  normalize={isValidNameWithSpace}
                  maxLength="40"
                  label="Middle Name"
                  component={renderTextField} />
              </div>
              <div className="col-sm-4 require">
                <Field
                  name="lastName"
                  type="text"
                  normalize={isValidNameWithSpace}
                  maxLength="40"
                  label="Last Name"
                  component={renderTextField} />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-8 require">
                {/* <Field
                  name="Address"
                  type="text"
                  maxLength="55"
                  label="Address"
                  // normalize = {isValidNameWithSpace}
                  fullWidth={true}
                  component={renderTextField}/> */}
                {/* {this.state.Address !== null || this.state.userId === null ? */}
                <GooglePlaceAutocomplete
                  getFullAddress={this.GetFullAddress}
                  id="Address"
                  labelText="Address"
                  errorText={this.state.isValidAddress ? '' : 'Please enter address.'}
                  value={this.state.Address}
                  isFullAddressEmpty={this.IsFullAddressEmpty}
                // hintText="Enter Address"
                // value= {this.state.address}
                />
                {/* : ''} */}
              </div>
              <div className="col-sm-4">
                <Field
                  name="apartmentNumber"
                  type="text"
                  maxLength='15'
                  label="Apt/Unit"
                  normalize={isValidApartmentWithSpace}
                  component={renderTextField} />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-4 require mt-35">
                <Field
                  name="countryID"
                  label="Country"
                  handleNewRequest={this.handleNewRequest}
                  options={this.props.masterCountry}
                  openOnFocus={true}
                  component={renderAutoCompleteSingleSelect} />
              </div>
              <div className="col-sm-4">
                <Field
                  name="city"
                  type="text"
                  maxLength="50"
                  label="City"
                  normalize={isValidNameWithSpace}
                  component={renderTextField} />
              </div>
              <div className="col-sm-4 require mt-35" >
                <Field
                  name="stateID"
                  label="State"
                  handleNewRequest={this.handleNewRequest}
                  openOnFocus={true}
                  options={this.state.filteredStatesByCountry}
                  component={renderAutoCompleteSingleSelect}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-sm-4 require">
                <Field
                  name="zip"
                  type="text"
                  maxLength="10"
                  label="ZIP"
                  normalize={normalizeZipCode}
                  component={renderTextField} />
              </div>
              <div className="col-sm-4 require">
                <Field
                  name="phoneNumber"
                  type="text"
                  maxLength="14"
                  label="Phone Number"
                  component={renderTextField}
                  normalize={normalizeMobile} />
              </div>
              <div className={this.state.isRenderingProvider ? 'col-sm-4 require' : 'col-sm-4'}>
                <Field
                  name="npiNumber"
                  type="text"
                  maxLength="10"
                  label="NPI #"
                  normalize={isInteger}
                  validate={this.state.isRenderingProvider ? validateNPI : null}
                  component={renderTextField} />
              </div>

            </div>
            <div className="row">
              <div className="col-sm-4">
                <Field
                  name="taxId"
                  type="text"
                  maxLength="9"
                  label="TaxId"
                  //normalize={isInteger}
                  component={renderTextField} />
              </div>
              <div className="col-sm-4 require">
                <Field
                  name="dob"
                  placeholder="Date of Birth"
                  component={renderDateField}
                  locale="en-US"
                  openToYearSelection={true}
                  maxDate={new Date()}
                  selected={this.props.dob ? this.props.dob : this.state.dob}
                  onDateChange={this.onDateChange} />
              </div>
              <div className="col-sm-4 require">
                <Field
                  name="doj"
                  placeholder="Date of Hire"
                  component={renderDateField}
                  openToYearSelection={true}
                  locale="en-US"
                  //minDate={this.state.doj}
                  //maxDate={new Date()}
                  selected={this.props.doj ? this.props.doj : this.state.doj}
                  onDateChange={this.onDateChange} />
              </div>
            </div>
            <div className="row">
              {(this.props.staffId && (this.props.roleName || '').toLowerCase() === 'admin') ?
                (<div className="col-sm-3 require" >
                  <Field
                    name="roleName"
                    label="Role"
                    disabled={true}
                    component={renderTextField} />
                </div>)
                : (this.props.staffId ? 
                    this.props.loggedInUserId === this.props.userID ? 
                      <div className="col-sm-3 require mt-35" >
                        <Field
                          name="roleID"
                          label="Role"
                          disabled={true}
                          handleNewRequest={this.handleNewRequest}
                          options={this.props.userRoles}
                          component={renderAutoCompleteSingleSelect} />
                      </div>
                      :
                      <div className="col-sm-3 require mt-35">
                         {this.props.editRolePermission ?
                            <Field
                              name="roleID"
                              label="Role"
                              handleNewRequest={this.handleNewRequest}
                              options={this.props.userRoles}
                              component={renderAutoCompleteSingleSelect} />
                            :
                            <Field
                              name="roleID"
                              label="Role"
                              disabled={true}
                              handleNewRequest={this.handleNewRequest}
                              options={this.props.userRoles}
                              component={renderAutoCompleteSingleSelect} />}
                      </div>
                    :
                    <div className="col-sm-3 require mt-35" >
                      <Field
                        name="roleID"
                        label="Role"
                        //disabled={true}
                        handleNewRequest={this.handleNewRequest}
                        options={this.props.userRoles}
                        component={renderAutoCompleteSingleSelect} />
                    </div>
                )
              }
              <div className="col-sm-3 require">
                <Field
                  name="email"
                  type="text"
                  maxLength="60"
                  label="Email"
                  disabled={!this.props.editUserEmailPermission}
                  onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Email')}
                  customError={displayCustomError('EMAIL', this.props.fieldError_Email)}
                  component={renderTextField} />
              </div>
              {!this.props.editUserEmailPermission && <div className="col-sm-3 mt-35">
                <CommonButton primary={true} label="Change Email Address" onTouchTap={this.changeEmailAddress}/>
              </div>}
              <div className="col-sm-3 mt-35">
                <Field
                  name="gender"
                  label="Gender"
                  handleNewRequest={this.handleNewRequest}
                  options={this.props.masterGender}
                  component={renderAutoCompleteSingleSelect} />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-4">
                <Field
                  name="caqhid"
                  type="text"
                  maxLength="15"
                  label="CAQH ID"
                  normalize={isValidName}
                  component={renderTextField} />
              </div>
              <div className="col-sm-4">
                <Field
                  name="employeeID"
                  type="text"
                  maxLength="100"
                  label="BHPN Practitioner ID"
                  normalize={isValidName}
                  component={renderTextField} />
              </div>
              <div className="col-sm-6 require mt-35">
                <Field
                  name="taxonomyCodeIds"
                  label="Taxonomy Code"
                  handleNewRequest={this.handleNewRequest}
                  options={this.state.Taxonomylist}
                  component={renderAutoCompleteSingleSelect} />
            </div>
            {this.state.displayOtherTaxonomy && 
              <div className="col-sm-4 require">
                  <Field
                    name="taxonomyCode"
                    type="text"
                    maxLength='100'
                    label="Rendering Provider Taxonomy Code"                                       
                    component={renderTextField} 
                    validate={this.state.displayOtherTaxonomy ? [validateOtherTaxonomy] : null}
                    />
              </div>}   
            </div>
           {/* <div className="row">
              <div className="col-sm-4">
                  <Field
                    name="payRate"
                    type="text"
                    maxLength="10"
                    label="Pay Rate"
                    normalize={normalizeRate}
                    component={renderTextField} />
                </div>
            </div> */}
            <div className="row">              
              <div className="col-sm-4 require">
                <Field
                  name="userName"
                  type="text"
                  maxLength="60"
                  autoComplete='email'
                  disabled={this.props.staffId && this.props.editUsernamePermission === false ? true : false}
                  onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Username')}
                  customError={displayCustomError('USERNAME', this.props.fieldError_Username)}
                  normalize={isValidName}
                  label="User Name"
                  component={renderTextField} />
              </div> 
              {this.props.staffId ? null :
              <div className="col-sm-4 require">
                <Field
                  name="newPassword"
                  type="password"
                  // type={this.state.showPassword ? 'text' : 'password'} autoComplete='new-password'
                  maxLength="30"
                  label="Password"
                  autoComplete='new-password'                               
                  component={renderTextField} />
                {/* <span className="eyeicon">{this.state.showPassword === false ?
                  <i onClick = {(e) => this.setState({ showPassword: true })} className="fa fa-eye" aria-hidden="true"></i> :
                  <i onClick = {(e) => this.setState({ showPassword: false })} className="fa fa-eye-slash" aria-hidden="true"></i>
                }</span> */}
              </div>}
              {this.props.staffId ? null :
              <div className="col-sm-4 require">
                <Field
                  name="confirmPassword"
                  type="password"
                  // type={this.state.showPassword ? 'text' : 'password'}
                  maxLength="30"
                  label="Confirm Password"
                  component={renderTextField} />
              </div>}
            </div>
            <div className="row">
              <div className="col-sm-4">
                <Field
                  name="language"
                  type="text"
                  maxLength="50"
                  label="Language"
                  normalize={isValidName}
                  component={renderTextField} />
              </div>
              <div className="col-sm-4 mt-35" >
                <Field
                  name="degreeID"
                  label="Degree"
                  handleNewRequest={this.handleNewRequest}
                  options={this.props.masterDegree}
                  component={renderAutoCompleteSingleSelect} />
              </div>
              <div className="col-sm-4 mt-35 require">
                <Field
                  name="payrollGroupID"
                  label="Payroll Group"
                  handleNewRequest={this.handleNewRequest}
                  options={this.props.payrollGroupList}
                  component={renderAutoCompleteSingleSelect} />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-4">
                  <Field
                    name="licenseNumber"
                    type="text"
                    maxLength='100'
                    label="State License Number(Add to Claims)"                                    
                    component={renderTextField} />
               </div>   
               {(this.props.agencyName.toUpperCase() === AMEGO || this.props.agencyName.toUpperCase() === AMEGOFL || this.props.agencyName.toUpperCase() === VIP || this.props.agencyName.toUpperCase() === STEPUPFAMILYSERVICES) ? 
               <div className="col-sm-4">
                <Field
                  name="employeeNumber"
                  type="text"
                  maxLength="50"
                  label="Employee Number"
                  normalize={isValidName}
                  component={renderTextField} />
              </div>
              :null}
              <div className="col-sm-8"></div>
            </div>
            {(this.props.agencyName.toUpperCase() === VIP || this.props.agencyName.toUpperCase() === CBF) ? 
            <div className="row">
              <div className="col-sm-4">
                  <Field
                    name="secondaryTaxonomyCode"
                    type="text"
                    maxLength='100'
                    label="Rendering Provider Taxonomy Code (Secondary)"                                       
                    component={renderTextField} />
              </div>
              <div className="col-sm-4">
                  <Field
                    name="secondaryLicenseNumber"
                    type="text"
                    maxLength='100'
                    label="State License Number (Secondary)"                                       
                    component={renderTextField} />
               </div>   
              <div className="col-sm-8"></div>
            </div>
            :null}
            {(this.props.agencyName.toUpperCase().startsWith(EBS) || this.props.agencyName.toUpperCase() === AIP || this.props.agencyName.toUpperCase() === 'FUTURES' || this.props.agencyName.toUpperCase() === VIP) ?  
            <div className="row">
                <div className="col-sm-4">
                   <Field
                    name="employeeKronosId"
                    type="text"
                    maxLength="50"
                    label="Employee Kronos ID"
                    normalize={isValidName}
                    //validate={validateEmployeeKronosId}
                    component={renderTextField} />
                </div>
                <div className="col-sm-4 mt-35">
                  <Field
                    name="exemptTypeId"
                    label="Exempt Type"
                    handleNewRequest={this.handleNewRequest}
                    options={this.props.exemptTypeList}
                    //validate={validateExemptTypeId}
                    component={renderAutoCompleteSingleSelect} />
                </div>
                <div className="col-sm-4 mt-35">
                  <Field
                    name="payrollPositionTypeId"
                    label="Payroll Position Type"
                    handleNewRequest={this.handleNewRequest}
                    options={this.props.payrollPositionTypeList}
                    //validate={validatePayrollPositionTypeId}
                    component={renderAutoCompleteSingleSelect} />
                </div>
            </div>
            :null}  

          {(this.props.agencyName.toUpperCase() === VIP || this.props.agencyName.toUpperCase() === FUTURES) ?  
            <div className="row">
                <div className="col-sm-4">
                   <Field
                    name="credentialsID"
                    type="text"
                    maxLength="100"
                    label="Credentials ID"                    
                    component={renderTextField} />
                </div>
                <div className="col-sm-4">
                  <Field
                      name="evalTitle"
                      type="text"
                      maxLength="100"
                      label="Eval Title"                    
                      component={renderTextField} />
                </div>                
            </div>
            :null}  

          <div className="row">
            <div className="col-sm-12">
              <div className="panel_title">
                <h3>License or Certification Details</h3>
                <i className="flaticon flaticon-interface-1"></i>
              </div>
            </div>
            <div className="col-sm-12">
              <FieldArray name="staffLicenseOrCertificateModel" component={this.renderLicenseTemplate}/>
            </div>
          </div>
            
          {(this.props.agencyName.toUpperCase() === TFABA || this.props.agencyName.toUpperCase() === ARROWS || this.props.agencyName.toUpperCase() === VIP) ? 
            <div className="row">
              <div className="col-sm-4">
                  <Field
                  name="medicaidId"
                  type="text"
                  maxLength="100"
                  label="Medicaid Id"
                  component={renderTextField} />
              </div>
            </div> :null}  

        {(this.props.agencyName.toUpperCase() === TFABA || this.props.agencyName.toUpperCase() === VIP) ?  
            <div className="row">                
                <div className="col-sm-4">
                  <Field
                      name="behaviorTechnicianMedicaidId"
                      type="text"
                      maxLength="100"
                      label="Behavior Technician Medicaid Id"                    
                      component={renderTextField} />
                </div>  
                <div className="col-sm-4">
                  <Field
                      name="leadAnalystMedicaidId"
                      type="text"
                      maxLength="100"
                      label="LeadAnalyst Medicaid Id"                    
                      component={renderTextField} />
                </div>                
            </div>
            :null}  

            <div className="row">
             <div className="col-sm-12 mt-35"></div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="panel_title">
                  <h3>Location</h3>
                  <i className="flaticon flaticon-location"></i>
                </div>
              </div>
              <div className="col-sm-4 require mt-35">

                <Field
                  name="staffLocationList"
                  label="Location"
                  handleNewRequest={this.handleNewRequestTag}
                  options={this.props.employeeLocationList}
                  component={renderAutoCompleteMultipleSelection}
                  fullWidth={true}
                />
              </div>
              <div className="col-sm-3 require mt-35">
                <Field
                  name="defaultLocation"
                  label="Default Location"
                  handleNewRequest={this.handleNewRequest}
                  options={this.props.staffDefaultLocationList}
                  disabled={this.props.staffLocationList && this.props.staffLocationList.length > 0 ? false : true}
                  component={renderAutoCompleteSingleSelect} />
              </div>
              <div className="col-sm-2">
                <Field
                  className="mt-35 mb0 rend-check"
                  name="isRenderingProvider"
                  label="Rendering Provider"
                  component={renderCheckBox}
                  onChange={(e) => this.checkRenderingProvider(e)}
                />
              </div>
               <div className="col-sm-3">
                  <Field
                    className="mt-35 mb0 rend-check"
                    name="isExemptFromBreakCalculation"
                    label="Exempt From Break Calculation"
                    component={renderCheckBox}                    
                  />
                </div>
            </div>    
             
            {this.props.agencyName.toUpperCase() === HYPERIONCENTER || this.props.agencyName.toUpperCase() === VIP ?            
              <div className="row">
                <div className="col-sm-4">
                    <Field
                      className="mt-35 mb0 rend-check"
                      name="isExemptFromDriveTime"
                      label="Exempt From Drive Time Calculation"
                      component={renderCheckBox}                    
                    />
                </div>           
                <div className="col-sm-4">
                    <Field
                      className="mt-35 mb0 rend-check"
                      name="isExemptFromMileage"
                      label="Exempt From Mileage Calculation"
                      component={renderCheckBox}                    
                    />
                </div>           
                <div className="col-sm-4">
                    <Field
                      className="mt-35 mb0 rend-check"
                      name="isExemptFromOverTime"
                      label="Exempt From Overtime Calculation"
                      component={renderCheckBox}                    
                    />
                </div>           
              </div>     
            : 
              <div className="row">
                <div className="col-sm-4">
                    <Field
                      className="mt-35 mb0 rend-check"
                      name="isExemptFromMileageCalculation"
                      label="Exempt From Mileage And Drive Time Calculation"
                      component={renderCheckBox}                  
                    />
                </div>         
              </div>   
            }
            <div className="row">
              <div className="col-sm-6">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="panel_title">
                      <h3>Assigned Staff</h3>
                      <i className="flaticon flaticon-two-users"></i>
                      <div className="sech_item_team">                     
                        <span className={this.state.selectAllStaff ? 'active' : ''} onClick={this.selectAll.bind(this, 'Staff')}>( Select All </span>
                        <span className={this.state.deSelectAllStaff ? 'active' : ''} onClick={this.deselectAll.bind(this, 'Staff')}> Deselect All ) </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-12 mt-35">
                    <Field
                      name="staffTeamList"
                      label="Staff"
                      handleNewRequest={this.handleNewRequestTeamStaff}
                      options={this.state.masterStaff}
                      component={renderAutoCompleteScheduling}
                      fullWidth={true}
                    />
                  </div>
                </div>        
              </div>
              <div className="col-sm-6">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="panel_title">
                      <h3>Assigned Clients</h3>
                      <i className="flaticon flaticon-two-users"></i>
                      <div className="sech_item_team">                     
                        <span className={this.state.selectAllPatient ? 'active' : ''} onClick={this.selectAll.bind(this, 'Client')}>( Select All </span>
                        <span className={this.state.deSelectAllPatient ? 'active' : ''} onClick={this.deselectAll.bind(this, 'Client')}> Deselect All ) </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-12 mt-35">
                    <Field
                      name="staffTeamClientsList"
                      label="Client"
                      handleNewRequest={this.handleNewRequestTeamStaff}
                      // options={this.props.patientlist}
                      options={this.state.allPatient}
                      component={renderAutoCompleteScheduling}
                      fullWidth={true}
                    />
                  </div>
                </div>        
              </div>
            </div> 

            <div className="row">
              <div className="col-sm-12">
                <div className="panel_title">
                  <h3>Tags</h3>
                  <i className="flaticon flaticon-commerce"></i>
                </div>
              </div>
              <div className="col-sm-6 mt-35">
                <Field
                  name="staffTagsModel"
                  label="Tags"
                  handleNewRequest={this.handleNewRequestTag}
                  options={this.props.masterTags}
                  component={renderAutoCompleteScheduling}
                  fullWidth={true}
                />
              </div>
            </div>            
            <div className="row">
                    <div className="col-sm-12">
                      <div className="panel_title">
                       {this.props.agencyName.toUpperCase() === KNOWBOUNDARIES ? <h3>GUSTO PAYROLL TITLE</h3> : <h3>Notes</h3> }
                        <i className="flaticon flaticon-interface-1"></i>
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <Field
                        name="note"
                        type="text"
                        maxLength="1000"
                        // normalize = {isValidNameWithSpace}
                        label="Enter Notes"
                        component={renderTextArea} />
                      <small className="blackfont font12">{this.props.Note ? 1000 - this.props.Note.length : 1000} Characters remaining </small>
                    </div>
                  </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="panel_title">
                  <h3>User Profile Photo</h3>
                  <i className="flaticon flaticon-picture"></i>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-4">
                <div className="uplaod_pic">
                  <FlatButton label="Upload Image" className="browse" labelPosition="before" style={styles.uploadButton} containerElement="label" fullWidth={true}>
                    <i className="fa fa-cloud-upload fa-2x" aria-hidden="true"></i>
                    <Field
                      name="photo"
                      type="file"
                      style={styles.uploadInput}
                      component={renderUploadField}
                      onChange={(e) => this._handleImageChange(e)}
                      label="Client Photo" />
                  </FlatButton>
                </div>
                <p className="ins_photo">(jpg, jpeg, bmp, png)</p>
              </div>
              <div className="col-sm-12 col-md-8">
                <div>
                  {this.state.userAvatar ?
                    <div className="insimage">
                      <img title="Insurance front image" src={this.state.userAvatar} alt={this.state.userAvatar} />
                      <b onClick={(e) => this.handleRemoveImage(e, 'front')} className="fa fa-times-circle valuefont" aria-hidden="true"></b>
                    </div>
                    :
                    ''
                  }
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 pt20 btn_rt">
                {this.props.loading ?
                  <CommonButton primary={true} className="loader_btn" disabled={true} label="Saving" />
                  : <CommonButton type="submit" primary={true} label="Save" />}
                <CommonButton className="ml_15" primary={true} label={'Save & Continue'} onTouchTap={handleSubmit(this.handleSaveContinue.bind(this))} />
              </div>
            </div>
          </form>
          {this.state.changeEmailAddressModel && <ChangeEmailAddressModal closeDialog={this.handleClose} userId={this.props.userID}/>}
        </div>
      </div>
    );
  }
}

const selector = formValueSelector('UserInfoForm'); // <-- same as form name

const mapStateToProps = (state, ownProps) => {
  // Start For Role Permission
  let userActionPermission = [], userScreenPermissionWithoutPage = [];
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'USER');
    userScreenPermissionWithoutPage = state.login.userPermission.screenPermissions.filter((obj) => obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'USER_ADD' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission
  let editRolePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'USER_ADD_EDIT_USER_ROLE')[0].permission : false;
  let viewAdminRolePermission = hasDefaultAccess ? true : userActionPermission && userActionPermission.filter((obj) => obj.actionKey === 'USER_ADD_VIEW_ADMIN_ROLES')[0] ? userActionPermission.filter((obj) => obj.actionKey === 'USER_ADD_VIEW_ADMIN_ROLES')[0].permission : false;
  let editUsernamePermission = hasDefaultAccess ? true : userScreenPermissionWithoutPage && userScreenPermissionWithoutPage.filter((obj) => obj.screenKey === 'USER_EDIT_STAFF_USERNAME')[0] ? userScreenPermissionWithoutPage.filter((obj) => obj.screenKey === 'USER_EDIT_STAFF_USERNAME')[0].permission : false;
  let editUserEmailPermission = hasDefaultAccess ? true : userScreenPermissionWithoutPage && userScreenPermissionWithoutPage.filter((obj) => obj.screenKey === 'USER_EDIT_EMAILS_WITHOUT_CONFIRM')[0] ? userScreenPermissionWithoutPage.filter((obj) => obj.screenKey === 'USER_EDIT_EMAILS_WITHOUT_CONFIRM')[0].permission : false;
  // End For Role Permission

  let initialValueData = {
    staffLicenseOrCertificateModel : [{}]
  };
  let masterLocations = [],
    masterTagsforStaff = [],
    // let staffLocationList = [];
    staffDefaultLocationList = [],
    patients = [],
    userID = 0;
    let agencyName = state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '';
    let countryName = agencyName.toUpperCase() === CONVERGENCY ? 'Canada' : 'US';

  if (state.user.master_data) {
    masterTagsforStaff = state.user.master_data.masterTagsforStaff || [];
    masterLocations = state.user.master_data.masterLocation || [];
    // let defaultCountry = (state.user.master_data.masterCountry || []).find((obj) => (obj.countryName || '').toUpperCase() === countryName);
    initialValueData = {
      'countryID': state.user.master_data && state.user.master_data.masterCountry ? state.user.master_data.masterCountry.filter((obj) => obj.countryName === countryName)[0].id : [],
      staffLicenseOrCertificateModel: [{}]
      
    };
  }
  if (ownProps.staffId && state.user.staffDetails && state.user.staffDetails.data) {
    let staffDetails = state.user.staffDetails.data,
      defaultLocation = null,
      newPassword = staffDetails.password,      
      confirmPassword = staffDetails.password,      
      staffTagsModel = (staffDetails.staffTagsModel || []).map((obj) => obj.tagID),
      staffTeamList = (staffDetails.staffTeamList || []).map((obj) => obj.staffteamid),
      staffTeamClientsList = (staffDetails.staffTeamClientsList || []).map((obj) => obj.staffteamclientid),      
      staffLocationList = (staffDetails.staffLocationList || []).map((obj) => {
        if (obj.isDefault) {
          defaultLocation = obj.id;
        }
        return obj.id;
      });

      let staffLicenseOrCertificateModel = [];
       
      if(staffDetails.staffLicenseOrCertificateModel && staffDetails.staffLicenseOrCertificateModel.length){
        staffDetails.staffLicenseOrCertificateModel.filter((data,i) => {
          staffLicenseOrCertificateModel.push({
            'id': data.id ? data.id : 0,
            'LicenseOrCertificateName': data.licenseOrCertificateName, 
            'LicenseOrCertificateNumber':data.licenseOrCertificateNumber,
            'issueDate':data.issueDate, 
            'expiryDate':data.expiryDate,
          })
          return staffLicenseOrCertificateModel;
        });
        // initialValueData['staffLicenseOrCertificateModel'] = staffLicenseOrCertificateModel && staffLicenseOrCertificateModel.length > 0 ? staffLicenseOrCertificateModel : [{}];
      }else{
        staffLicenseOrCertificateModel =[{}];
      }
    initialValueData = {
      ...staffDetails,
      newPassword,
      confirmPassword,
      staffLocationList,
      defaultLocation,
      staffTeamList,
      staffTeamClientsList,
      staffTagsModel,
      staffLicenseOrCertificateModel:staffLicenseOrCertificateModel,
    };

    userID = staffDetails.userID;
    if(state.user.staffDetails.data.taxonomyCode !== '' && state.user.staffDetails.data.taxonomyCode !== undefined && state.user.staffDetails.data.taxonomyCode !== '106S00000X' && state.user.staffDetails.data.taxonomyCode !== '106E00000X' && state.user.staffDetails.data.taxonomyCode !== '103K00000X') 
    {
      initialValueData.taxonomyCode = state.user.staffDetails.data.taxonomyCode;
      initialValueData.taxonomyCodeIds = 'Other';
    }
    else {      
      initialValueData.taxonomyCodeIds = state.user.staffDetails.data.taxonomyCode;
    }  
  }
  let StaffLocationListProp = selector(state, 'staffLocationList');
  if (state.user.master_data && state.user.master_data.masterLocation) {
    if (StaffLocationListProp && StaffLocationListProp.length) {
      StaffLocationListProp.map((selectedLocation, i) => {
        state.user.master_data.masterLocation.map((masterLocation, index) => {
          if (selectedLocation === masterLocation.id) {
            staffDefaultLocationList.push(masterLocation);
          }
          return staffDefaultLocationList;
        });
        return staffDefaultLocationList;
      });
    }
  }

  if (state.user.patientList && state.user.patientList.data) {
    patients = state.user.patientList.data.patients;
  }
  let fieldError_Username = null;
  let fieldError_Email = null;

  if (state.appConfig && state.appConfig.fieldError) {
    fieldError_Username = state.appConfig.fieldError.filter((obj, i) => obj.data === 'USERNAME');
    fieldError_Email = state.appConfig.fieldError.filter((obj, i) => obj.data === 'EMAIL');
  }
 //  console.log('state.login.loginUserInfo....', state.login.loginUserInfo)
  return {
    master_data: state.user.master_data,
    patientlist: patients,
    activeUser: state.user.activeUser,
    staffDetails: state.user.staffDetails,
    saved_StaffDetails: state.user.saved_StaffDetails,
    employeeLocationList: masterLocations,
    initialValues: initialValueData,
    formMeta: getFormMeta('UserInfoForm')(state),
    countryID: selector(state, 'countryID'),
    dob: selector(state, 'dob'),
    doj: selector(state, 'doj'),
    issueDate:selector(selector,'issueDate'),
    expiryDate:selector(selector,'expiryDate'),
    RoleID: selector(state, 'RoleID'),
    roleName: selector(state, 'roleName'),
    staffLocationList: selector(state, 'staffLocationList'),
    isRequirednpiNumber: selector(state, 'isRenderingProvider'),
    staffDefaultLocationList: staffDefaultLocationList,
    loading: state.user.loading,
    // masterTags: state.user.get_master_tags,
    masterTags: masterTagsforStaff,
    //masterRoles: state.user.master_data && state.user.master_data.masterRoles ? state.user.master_data.masterRoles : [],
    masterState: state.user.master_data && state.user.master_data.masterState ? state.user.master_data.masterState : [],
    masterCountry: state.user.master_data && state.user.master_data.masterCountry ? state.user.master_data.masterCountry : [],
    masterGender: state.user.master_data && state.user.master_data.masterGender ? state.user.master_data.masterGender : [],
    masterDegree: state.user.master_data && state.user.master_data.masterDegree ? state.user.master_data.masterDegree : [],
    payrollGroupList: state.user.master_data && state.user.master_data.payrollGroup ? state.user.master_data.payrollGroup : [],
    exemptTypeList: state.user.master_data && state.user.master_data.exemptType ? state.user.master_data.exemptType : [],
    payrollPositionTypeList: state.user.master_data && state.user.master_data.payrollPositionType ? state.user.master_data.payrollPositionType : [],
    // staffTagsModel: selector(state, 'staffTagsModel'),
    fieldError_Username: fieldError_Username,
    fieldError_Email: fieldError_Email,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
    access_token: state.login.access_token,
    editRolePermission: editRolePermission,
    hasDefaultAccess: hasDefaultAccess,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    userID: userID,
    loggedInUserId: state.login.loginUserInfo && state.login.loginUserInfo.userID ? state.login.loginUserInfo.userID : 0,
    userRoles: state.user.userRoles && state.user.userRoles.data ? state.user.userRoles.data : null,
    viewAdminRolePermission: viewAdminRolePermission,
    editUsernamePermission: editUsernamePermission,
    editUserEmailPermission: editUserEmailPermission,
  };
};
UserInfo = reduxForm({
  form: 'UserInfoForm',
  validate,
  //asyncValidate,
  //asyncBlurFields: ['npiNumber', 'isRenderingProvider'],
  enableReinitialize: true,
})(UserInfo);


export default connect(mapStateToProps, { asyncValidateAction, getMasterData, SaveUserDetails, getStaffDetailsById, checkFieldExistence, clearFieldErrorArray, showUsersSubMenus, getPatientList, getUserRoles })(UserInfo);



// WEBPACK FOOTER //
// ./src/modules/users/User/UserInfo.js